import { createApi } from '@reduxjs/toolkit/query/react';
import { apiSahClientHcpUnspentFunds } from 'tsx/constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

export const typePrefix = 'hcp-unspent-funds';

interface ClientHcpUnspentFunds {
  id: string;
  company_id: number;
  provider_held: number;
  commonwealth_held: number;
  client_held: number;
}

export const clientHcpUnspentFundsApi = createApi({
  reducerPath: 'clientHcpUnspentFundsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahClientHcpUnspentFunds }),
  tagTypes: ['clientHcpUnspentFunds'],
  endpoints: (builder) => ({
    getClientHcpUnspentFunds: builder.query<ClientHcpUnspentFunds, Request>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'clientHcpUnspentFunds', id: 'LIST' }],
      transformResponse: (payload) => unwrap<ClientHcpUnspentFunds>(payload),
    }),
  }),
});

export const { useGetClientHcpUnspentFundsQuery, useLazyGetClientHcpUnspentFundsQuery } = clientHcpUnspentFundsApi;
